import { StatusBadge, Table, TableBody, TableCell, TableHeader, TableRow } from '@catering/ui';
import { Link } from '@tanstack/react-router';
import type { JSX } from 'react';

import type { ContractListItem } from '../../../contracts/api';
import { formatCalendarDate } from '../../../contracts/format-calendar-date';

export interface ContractTableProps {
  items: ContractListItem[];
  customerNames: Record<string, string>;
  /** Present only when the actor sees several points of sale: adds the column. */
  unitNames?: Record<string, string>;
}

export function ContractTable({
  items,
  customerNames,
  unitNames,
}: ContractTableProps): JSX.Element {
  return (
    <Table>
      <caption className="sr-only">Contratos</caption>
      <thead>
        <tr>
          <TableHeader>Código</TableHeader>
          <TableHeader>Cliente</TableHeader>
          {unitNames === undefined ? null : <TableHeader>Punto de venta</TableHeader>}
          <TableHeader>Vigencia</TableHeader>
          <TableHeader>Estado</TableHeader>
        </tr>
      </thead>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.id}>
            <TableCell>
              <Link
                to="/contracts/$contractId"
                params={{ contractId: item.id }}
                className="font-medium text-slate-900 hover:underline"
              >
                {item.code}
              </Link>
            </TableCell>
            <TableCell>{customerNames[item.customerId] ?? item.customerId}</TableCell>
            {unitNames === undefined ? null : (
              <TableCell>{unitNames[item.operatingUnitId] ?? '—'}</TableCell>
            )}
            <TableCell>{formatValidity(item)}</TableCell>
            <TableCell>
              <StatusBadge domain="contract" status={item.status} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

function formatValidity(item: ContractListItem): string {
  const start = formatCalendarDate(item.startDate);

  if (item.endDate === null) {
    return `Desde ${start}`;
  }

  return `${start} – ${formatCalendarDate(item.endDate)}`;
}
